// removed by extract-text-webpack-plugin
module.exports = {"Section":"Section__Section___MPokR","SectionBorder":"Section__SectionBorder___16rJU","SectionDivider":"Section__SectionDivider___2plaR","horizontalPadding":"Section__horizontalPadding___21im-","verticalPadding":"Section__verticalPadding___2fkst","gutterPadding":"Section__gutterPadding___3pL97","ContainerInsideSection":"Section__ContainerInsideSection___3Ia5p","Center":"Section__Center___2QZFw"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Section/Section.less
// module id = 1219
// module chunks = 0 1